import { render, staticRenderFns } from "./xeImage.vue?vue&type=template&id=997f953e"
import script from "./xeImage.vue?vue&type=script&lang=js"
export * from "./xeImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports